import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=0c07ec2a&scoped=true"
import script from "./pop.vue?vue&type=script&lang=js"
export * from "./pop.vue?vue&type=script&lang=js"
import style0 from "./pop.vue?vue&type=style&index=0&id=0c07ec2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07ec2a",
  null
  
)

export default component.exports